module.exports = __webpack_public_path__ + "static/media/s3.0c03d253.svg";